<template>
  <div class="text-[#FFFFFF] text-14px h-full cockpit overflow-auto">
    <div class="leftTop w-full">
      <CustomerTitle class="my-10px" title="应急组织机构">
        <template v-slot:customerSlot>
          <i class="el-icon-d-arrow-right" @click="moreTissue"></i>
        </template>
      </CustomerTitle>
      <div class="pr-4px">
        <div class="flex leading-26px" v-for="(item, index) in peopleList" :key="index">
          <p class="text-right w-130px text-hex-ffffff99 text-overflow">
            {{ item.organizationName }}：
          </p>
          <p class="text-left flex-1 text-overflow ">{{ item.peopleList }}</p>
        </div>
      </div>
    </div>
    <div class="leftCenter w-full">
      <categoryTitle class="my-10px" title="应急预案" />
      <div class="flex justify-between text-center">
        <div
          class="text-center"
          v-for="(plan, index) in planList"
          :key="index"
          :class="index === 2 ? 'w-114px' : ''"
          @click="viewPlan(plan)"
        >
          <div class="text-center text-hex-45f2eb">{{ plan.num }}</div>
          <img
            class="m-auto"
            :src="currentPlan === plan.name ? plan.img_active : plan.img_normal"
            alt=""
          />
          <div class="plan-type-bg text-center h-26px leading-26px">{{ plan.name }}</div>
        </div>
      </div>
    </div>
    <div class="leftCenter w-full relative">
      <categoryTitle class="my-15px" title="应急资源" />
      <el-select
        v-model="curArea"
        popper-class="visualization-select-popper"
        :popper-append-to-body="false"
        class="absolute top-[-10px] right-0"
        clearable
        filterable
        @change="areaIdChange"
      >
        <el-option label="全厂" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="item in areaList"
          :key="item.id"
        ></el-option>
      </el-select>
      <div class="flex flex-wrap">
        <div
          v-for="(item, key) in typeList"
          :key="key"
          class="flex items-center w-1/2 cursor-pointer"
          :class="key < 2 ? 'mb-10px' : ''"
          @click="openRight(item)"
        >
          <img class="w-33px h-33px" :src="item.img_normal" alt="" />
          <div
            class="resource-type flex flex-1 h-28px leading-28px justify-between px-5px"
            :class="key % 2 === 0 ? 'mr-10px' : ''"
          >
            <span>{{ item.name }}</span>
            <div>
              <span class="text-hex-fa8b14 text-num">{{ item.num }}</span>
              <span class="text-hex-5cf5ff text-num text-12px" v-if="key === 3"
                >/{{ item.total }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="pt-10px flex items-center justify-between">
        <tableButtonGroup v-model="activeTab" :list="tabList" />
        <i
          class="iconfont text-16px icon-line-circleAdd mr-10px cursor-pointer"
          @click="createHandle"
          v-show="activeTab === '应急事件'"
        ></i>
      </div>
      <el-table
        class="mt-10px"
        :data="byTableData"
        height="350px"
        highlight-current-row
        ref="singleTable"
        v-loading="loading"
        v-el-table-infinite-scroll="loadMore"
        @current-change="singleCurrentChange"
        v-show="activeTab === '应急事件'"
      >
        <el-table-column label="应急事件" show-overflow-tooltip prop="name" width="120px">
          <template slot="header">
            <span class="w-20px inline-block"></span>
            应急事件
          </template>
          <template slot-scope="scope">
            <span class="w-20px h-10px inline-block activeBg"></span>
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="风险等级" show-overflow-tooltip prop="level"></el-table-column>
        <el-table-column label="事件状态" show-overflow-tooltip prop="statusText"></el-table-column>
        <el-table-column label="操作" width="50px" show-overflow-tooltip prop="isTicketExtension">
          <template slot-scope="scope">
            <i
              class="iconfont text-16px"
              :class="scope.row.statusText !== '已处置' ? 'icon-bg-flag' : 'icon-bg-display'"
              @click="viewHandle(scope.row)"
            ></i>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        v-loading="monitorTableLoading"
        class="mt-10px"
        :data="monitorTableData"
        height="350px"
        highlight-current-row
        row-key="id"
        ref="monitorTable"
        v-show="activeTab === '应急监控'"
        @current-change="monitorCurrentChange"
      >
        <!-- <el-table-column label="序号" type="index" width="50px"></el-table-column> -->
        <el-table-column label="摄像头名称" show-overflow-tooltip prop="name">
          <template slot="header">
            <span class="w-20px inline-block"></span>
            摄像头名称
          </template>
          <template slot-scope="scope">
            <span class="w-20px h-10px inline-block activeBg"></span>
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="所属区域" show-overflow-tooltip prop="areaName"></el-table-column>
        <el-table-column label="操作" width="50px" show-overflow-tooltip prop="isTicketExtension">
          <template slot-scope="scope">
            <i class="iconfont text-16px icon-bg-display" @click="viewScamera(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <MiddleCom />
    <ControlCenter @close="controlCenterClose" ref="controlCenter" />
  </div>
</template>

<script>
import { WorkTicketApi, OperateTicketApi } from '@wiz-api/huizhou2'
import { IOTDeviceApi } from '@wiz-api/iot-device-management'
import { instance as cloudRender } from 'wiz-cloud-render'
import {
  PlanApi,
  EvacuatePathApi,
  EvacuateSafetyIslandApi,
  SuppliesSiteApi,
  SuppliesManagementApi,
  AccidentEventsResponseDisposeApi,
  AccidentEventsResponseRecordingApi,
  OrganizationApi,
  RoleApi,
  EmployeeApi,
  EquipmentMonitoringApi,
} from '@wiz-api/emergency-management'
import elTableInfiniteScroll from 'el-table-infinite-scroll'
import { AreaApi } from '@wiz-api/area-management'
import { find, values } from 'lodash'
import tableButtonGroup from '../../../../../components/cockpit/TableButtonGroup'
import categoryTitle from '../../../../../components/cockpit/CategoryTitle'
import ControlCenter from './ControlCenter'
import CustomerTitle from './CategoryTitle'
import MiddleCom from './MiddleCom'
import bus from './bus'

const accidentEventsResponseDisposeApi = new AccidentEventsResponseDisposeApi()
const accidentEventsResponseRecordingApi = new AccidentEventsResponseRecordingApi()

const roleApi = new RoleApi()
const employeeApi = new EmployeeApi()
const organizationApi = new OrganizationApi()
const planApi = new PlanApi()
const workTicketApi = new WorkTicketApi()
const operateTicketApi = new OperateTicketApi()
const areaApi = new AreaApi()
const evacuatePathApi = new EvacuatePathApi()
const evacuateSafetyIslandApi = new EvacuateSafetyIslandApi()
const IOTdeviceApi = new IOTDeviceApi()
const suppliesSiteApi = new SuppliesSiteApi()
const suppliesManagementApi = new SuppliesManagementApi()
const equipmentMonitoringApi = new EquipmentMonitoringApi()

export default {
  name: 'emergency-disposal',
  props: {
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    customProps: {
      type: Object,
      default: () => {},
    },
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    openDialog: {
      type: Object,
      default: () => {
        return {
          name: ''
        }
      }
    },
  },
  components: { tableButtonGroup, categoryTitle, CustomerTitle, MiddleCom, ControlCenter },
  directives: {
    'el-table-infinite-scroll': elTableInfiniteScroll,
  },
  data() {
    return {
      singleTableId: '',
      monitorTableId: '',
      monitorTableLoading: false,

      curArea: '',
      areaList: [],
      loading: false,
      peopleList: [],
      planList: [
        {
          name: '综合预案',
          num: 0,
          img_normal: require('../../../assets/images/emergencyDisposal/comprehensive1.png'),
          img_active: require('../../../assets/images/emergencyDisposal/comprehensive2.webp'),
          safeName: '综合应急预案',
        },
        {
          name: '专项预案',
          num: 0,
          img_normal: require('../../../assets/images/emergencyDisposal/special1.png'),
          img_active: require('../../../assets/images/emergencyDisposal/special2.webp'),
          safeName: '专项应急预案',
        },
        {
          name: '现场处置预案',
          num: 0,
          img_normal: require('../../../assets/images/emergencyDisposal/onsiteDisposal1.png'),
          img_active: require('../../../assets/images/emergencyDisposal/onsiteDisposal2.webp'),
          safeName: '现场处置方案',
        },
      ],
      currentPlan: '',
      planActive: -1,
      typeList: [
        {
          name: '应急物资',
          num: 0,
          img_normal: require('../../../assets/images/emergencyDisposal/emergencySuppliesTab1.png'),
        },
        {
          name: '疏散通道',
          num: 0,
          img_normal: require('../../../assets/images/emergencyDisposal/escapeRouteTab1.png'),
        },
        {
          name: '安全岛',
          num: 0,
          img_normal: require('../../../assets/images/emergencyDisposal/safeIslandTab1.png'),
        },
        {
          name: '应急监控',
          num: 0,
          total: 0,
          img_normal: require('../../../assets/images/emergencyDisposal/emergencyMonitTab1.png'),
        },
      ],
      activeTab: '应急监控',
      tabList: ['应急监控', '应急事件'],
      tableData: [],
      byTableData: [],
      tableDataLoading: false,
      page: {
        pageNo: 1,
        pageSize: 3,
        totalCount: 0,
      },
      currentPanel: '',
      panelRow: '',
      miniorParams: {},
      monitorTableData: [],
    }
  },
  computed: {},
  watch: {
    curArea(id) {
      const sendAreaIdEvent = new CustomEvent('sendAreaId', {
        detail: {
          areaId: id,
          modelId: this.sourceId,
        },
      })
      window.dispatchEvent(sendAreaIdEvent)
      this.getSuppliesCountByArea()
      this.getPathCount()
      this.getmonitorList()
      this.getmonitorCount()

      // this.getSuppliesCountByArea()
      // if (!id) {
      //   this.getSuppliesCount()
      // }
    },
    openDialog: {
      immediate: true,
      handler() {
        if (this.openDialog?.name) {
          if (this.openDialog?.name === 'people') {
            this.$nextTick(() => this.moreTissue())
          }else if (this.openDialog?.name === 'goods'){
            this.$nextTick(() => {
              this.$emit('transferEvent', {
                toCom: { code: 'EmergencyMatter', origin: 'EmergencyDisposal', name: '应急物资台账' },
                type: 'basic',
                props: {
                  data: this.openDialog?.data,
                }
              })
            })
          }
        }
      }
    }
  },
  methods: {
    // 获取风险区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        modelId: this.sourceId,
        skipCount: 0,
        maxResultCount: 1000,
      })
      if (!err && res) {
        this.areaList = res.items
      }
    },
    async getPathCount() {
      // const [err, res] = await evacuatePathApi.getCount({
      //   modelId: this.sourceId,
      //   areaId: this.curArea,
      // })
      // if (!err) {
      //   this.typeList[1].num = res
      // }
      const [err, res] = await evacuatePathApi.getCount({
        sceneId: this.sourceId,
        areaId: this.curArea,
      })
      if (!err) {
        this.typeList[1].num = res
      }
    },
    // 没有根据区域查询字段
    async getIslandCount() {
      const [err, res] = await evacuateSafetyIslandApi.getCount({
        sceneId: this.sourceId,
      })
      if (!err) {
        this.typeList[2].num = res
      }
    },
    async getmonitorCount() {
      const data = {
        areaId: this.curArea,
      }
      if (!data.areaId) {
        data.areaIds = this.areaList.map((item) => {
          return item.id
        })
      }
      const [err, res] = await equipmentMonitoringApi.getOnlineCount(data)
      if (!err) {
        this.typeList[3].num = res.onlineCount
        this.typeList[3].total = res.totalCount
      }
    },
    // async getSuppliesCount() {
    //   const [err, res] = await suppliesSiteApi.getSiteSceneList({
    //     body: {
    //       sceneId: this.sourceId,
    //     },
    //   })
    //   if (!err) {
    //     this.typeList[0].num = res.totalCount
    //   }
    // },

    async getSuppliesCountByArea() {
      const ids = this.areaList.map((item) => {
        return item.id
      })
      const [err, res] = await suppliesManagementApi.getList({
        areaId: this.curArea ? [this.curArea] : ids,
      })
      if (!err) {
        this.typeList[0].num = res.totalCount
      }
    },
    async getPlanCount(data) {
      const [err, res] = await planApi.getList({
        typeName: data.safeName,
      })
      if (!err) {
        data.num = res.totalCount
      }
    },
    // 查看预案列表
    viewPlan(data) {
      this.currentPlan = data.name
      this.$emit('transferEvent', {
        toCom: { code: 'PlanList', origin: 'EmergencyDisposal', name: `${data.name}列表` },
        type: 'mainComponent',
        props: {
          typeName: data.safeName,
        },
      })
    },
    // 更多组织
    moreTissue() {
      bus.$emit('translate', { row: {}, type: 'tissue' })
    },
    // 加载更多
    loadMore() {
      if (!this.tableDataLoading && this.tableData.length < this.page.totalCount) {
        this.page.pageNo += 1
        this.getTicketsList()
      }
    },
    singleCurrentChange(newRow, oldRow) {
      if (!this.singleTableId) return
      if (newRow && this.singleTableId === newRow.id) {
        this.$refs.singleTable.setCurrentRow(newRow)
      } else {
        this.$refs.singleTable.setCurrentRow(oldRow)
      }
    },
    monitorCurrentChange(newRow, oldRow) {
      if (!this.monitorTableId) return
      if (newRow && this.monitorTableId === newRow.id) {
        this.$refs.monitorTable.setCurrentRow(newRow)
      } else {
        this.$refs.monitorTable.setCurrentRow(oldRow)
      }
    },
    createHandle() {
      this.$refs.controlCenter.closeAllDialog()
      this.$nextTick(() => {
        this.$refs.controlCenter.accidentDialog = true
      })
    },

    viewHandle(row) {
      this.singleTableId = row.id
      // 等待接口 模拟带相应
      if (row.statusText === '待响应') {
        this.$refs.controlCenter.closeAllDialog()
        this.$nextTick(() => {
          this.$refs.controlCenter.mapResponseDialog = true
          this.$refs.controlCenter.mapResponseformData = row
        })
      } else {
        this.$refs.controlCenter.closeAllDialog()
        this.$emit('transferEvent', {
          toCom: { code: 'EmergencyDisposalCard', origin: 'EmergencyDisposal', name: '应急处置卡' },
          type: 'basic',
          props: {
            ...row,
          },
        })
      }
    },
    controlCenterClose() {
      this.$emit('transferEvent', {
        toCom: { code: 'EmergencyDisposalCard', origin: 'EmergencyDisposal', name: '应急处置卡' },
        type: 'close',
      })
      this.findList()
    },
    async findList() {
      this.loading = true
      const data = {
        skipCount: 0,
        maxResultCount: 999,
      }
      // 处置接口
      // const [err, res] = await accidentEventsResponseDisposeApi.getPagaeList(data)

      // 待响应接口
      // const [err, res] = await accidentEventsResponseRecordingApi.waitResponsePageList(data)

      // 汇总接口
      const [err, res] = await accidentEventsResponseRecordingApi.getDesktopList(data)
      if (!err) {
        // this.byTableData = res.items
        this.byTableData = res
        this.loading = false
      }
    },
    areaIdChange() {
      // this.$emit('transferEvent', {
      //   toCom: { code: 'EmergencyMatter', origin: 'EmergencyDisposal', name: '应急物资台账' },
      //   type: 'basic',
      //   props: {
      //     areaId: this.curArea,
      //   },
      // })
      // const openEvent = new CustomEvent('areaIdChange', {
      //   detail: {
      //     areaId: this.curArea,
      //   },
      // })
      // window.dispatchEvent(openEvent)
    },
    openRight(row) {
      let code = ''
      if (row.name === '应急物资') {
        this.$emit('transferEvent', {
          toCom: { code: 'EmergencyMatter', origin: 'EmergencyDisposal', name: '应急物资台账' },
          type: 'basic',
          props: {
            ...row,
            areaId: this.curArea,
            sceneId: this.sourceId,
          },
        })
        code = 'EmergencySupplies'
      }
      if (row.name === '疏散通道') {
        this.$emit('transferEvent', {
          toCom: { code: 'EscapeRoute', origin: 'EmergencyDisposal', name: '疏散通道信息' },
          type: 'basic',
          props: {
            ...row,
            areaId: this.curArea,
            sceneId: this.sourceId,
          },
        })
        code = 'EscapeRoute'
      }
      if (row.name === '安全岛') {
        this.$emit('transferEvent', {
          toCom: { code: 'SafetyIsland', origin: 'EmergencyDisposal', name: '安全岛台账' },
          type: 'basic',
          props: {
            ...row,
            areaId: this.curArea,
            sceneId: this.sourceId,
          },
        })
        code = 'SafetyIsland'
      }
      if (row.name === '应急监控') {
        this.$emit('transferEvent', {
          toCom: { code: 'EmergencyMonitor', origin: 'EmergencyDisposal', name: '应急监控' },
          type: 'basic',
          props: {
            ...row,
            areaId: this.curArea,
            sceneId: this.sourceId,
          },
        })
        code = 'EmergencyMonitor'
      }
      const event = new CustomEvent('setLabelChecked', {
        detail: {
          code,
          checked: true,
        },
      })
      window.dispatchEvent(event)
    },
    // 获取组织数据
    async getOrgData() {
      let roleList = []
      const [err, res] = await roleApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        roleList = res.items
      }
      roleList = roleList.slice(0, 5)
      const list = new Map()
      const [err2, res2] = await employeeApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err2) {
        const merber = res2.items || []
        merber.forEach((item) => {
          if (list.has(item.roleName)) {
            list.get(item.roleName).push(item.userName)
          } else {
            list.set(item.roleName, [item.userName])
          }
        })
      }
      roleList.forEach((item) => {
        item.peopleList = list.get(item.name)?.join(',') || ''
      })
      this.peopleList = roleList
    },
    // 获取预案数据
    async getPlanData() {
      this.planList.forEach(async (item) => {
        const [err, res] = await planApi.getList({
          skipCount: 0,
          statusArr: ['4', '5'],
          maxResultCount: 999,
          typeName: item.safeName,
        })
        if (err) return
        item.num = res.totalCount
      })
    },
    // 获取应急监控列表
    async getmonitorList() {
      const data = {
        skipCount: 0,
        maxResultCount: 999,
        areaId: this.curArea,
        status: 1,
      }
      this.monitorTableLoading = true
      if (!data.areaId) {
        data.areaIds = this.areaList.map((item) => {
          return item.id
        })
      }
      const [err, res] = await equipmentMonitoringApi.pagedListQuery(data)
      this.monitorTableLoading = false
      if (err) return
      this.monitorTableData = res.items
    },
    // 打开摄像头
    viewScamera(data) {
      if (data.isPoint) {
        cloudRender.Engine.player.Native.Camera.moveToPos(JSON.parse(data.threeDPosition), 0, 10, 2)
      }
      this.monitorTableId = data.id
      this.$refs.monitorTable.setCurrentRow(data)
      bus.$emit('translate', { row: data, type: 'camera' })
    },
  },
  beforeDestroy() {},
  async created() {
    this.findList()
    this.getPlanData()
    this.getOrgData()
    await this.getAreaList()
    this.getmonitorList()
    this.getPathCount()
    this.getIslandCount()
    this.getmonitorCount()
    // this.getSuppliesCount()
    this.getSuppliesCountByArea()
    window.addEventListener('controlCenterClose', this.controlCenterClose)
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background: transparent;
}
::v-deep .current-row {
  .activeBg {
    background-image: url('../../../assets/images/smartSecurity/tableSelectedIcon.png');
    background-repeat: no-repeat;
    // background-size: 100% 100%;
  }
}
.plan-type-bg {
  background: url('../../../assets/images/emergencyDisposal/planBG1.png');
  background-size: 100% 100%;
}

.resource-type {
  background: linear-gradient(90.04deg, #00424b 0%, #007f8c 100%);
  border: 1px solid #59e1ef7f;
  border-left: none;
}
.text-num {
  font-family: PangMenZhengDaoTitleBody;
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
